export default {
  API_URL: "http://localhost:5000/v1",
  STRAPI_API_URL: import.meta.env.VITE_STRAPI_API_URL || "https://cms.xs2event.com/api",
  strapiType: "Webpage",
  CDN_URL: "https://cdn.xs2event.com",
  ENV: "development",
  SENTRY_ENABLE: false,
  VERSION: "56d88dcc",
  FLAGS_BASE_URL: "https://cdn.xs2event.com/flags-test",
  WEBAPP: "webpage3",
};